import PageShell from "@/components/PageShell";
import usePricing from "@/hooks/usePricing";
import { applyPrices } from "@/priceTokens";
import { SITE } from "@/seoData";
import { ALL_FAQS } from "@/siteContent";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const faqs = applyPrices(ALL_FAQS, usePricing());
  const canonical = `${SITE}/faq`;
  const seo = {
    title: "Junk Removal FAQ San Diego | Prices, Pickup & What We Take | CleanOut247",
    description: "Answers to common junk removal questions in San Diego: how much it costs, same-day pickup, what we take, payment methods and the areas we serve.",
    canonical,
    jsonLd: [
      { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
      { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
        { "@type": "ListItem", position: 2, name: "FAQ", item: canonical },
      ] },
    ],
  };
  return (
    <PageShell seo={seo} eyebrow="FAQ" h1="Junk Removal Questions, Answered"
      lead="Straight answers about junk removal prices, same-day pickup, what we take and how to pay.">
      <section className="px-5 lg:px-8 py-16">
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-list">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-b border-[#E4E4E7]">
                <AccordionTrigger className="text-left font-display font-bold text-lg text-[#15306E] hover:text-[#46A01E] hover:no-underline py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-[#52525B] text-base leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </PageShell>
  );
}
